import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FontSize = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.45177 2.50488C2.17562 2.50488 1.95177 2.72874 1.95177 3.00488C1.95177 3.28103 2.17562 3.50488 2.45177 3.50488H7.60246C7.59945 3.52708 7.59789 3.54974 7.59789 3.57277L7.5979 14.9952C7.5979 15.2713 7.82175 15.4952 8.0979 15.4952C8.37404 15.4952 8.5979 15.2713 8.5979 14.9952L8.59789 3.57277C8.59789 3.54974 8.59634 3.52708 8.59333 3.50488H13.7981C14.0743 3.50488 14.2981 3.28103 14.2981 3.00488C14.2981 2.72874 14.0743 2.50488 13.7981 2.50488H2.45177Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1674 8.76469C10.3627 8.95995 10.6793 8.95995 10.8745 8.76469L12.498 7.14122L14.1215 8.76469C14.3167 8.95995 14.6333 8.95995 14.8286 8.76469C15.0238 8.56942 15.0238 8.25284 14.8286 8.05758L12.8516 6.08056C12.6563 5.8853 12.3397 5.8853 12.1445 6.08056L10.1674 8.05758C9.97218 8.25284 9.97218 8.56942 10.1674 8.76469Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1674 10.8581C10.3627 10.6629 10.6793 10.6629 10.8745 10.8581L12.498 12.4816L14.1215 10.8581C14.3167 10.6629 14.6333 10.6629 14.8286 10.8581C15.0238 11.0534 15.0238 11.37 14.8286 11.5652L12.8516 13.5422C12.6563 13.7375 12.3397 13.7375 12.1445 13.5422L10.1674 11.5652C9.97218 11.37 9.97218 11.0534 10.1674 10.8581Z"
        fill={color}
      />
    </svg>
  )
})

export default FontSize
